import React from 'react';
import Panel from 'components/Shared/Panel/Panel';
import styles from './ErrorModalStyles.module.scss';

/**
 * ErrorModal — generic confirm / notice dialog. Layout ported from WWTBAM and
 * framed with the shared Pointless Panel (purple/silver app theme). API is
 * unchanged from the previous Pointless modal:
 *   title, message, callback (+ callbackText), callback2 (+ callbackText2),
 *   styles (extra className merged onto the backdrop — e.g. "d-flex").
 *
 * The confirm/deny buttons keep WWTBAM's specific flat-gradient "raised pill"
 * styling (blue = secondary/dismiss, red = primary/action) — only the font is
 * swapped to the Pointless Avant face. The first button is the
 * secondary/dismiss action; the optional second is the primary action.
 */
export default function ErrorModal({
    title,
    message,
    callback,
    callbackText,
    callback2,
    callbackText2,
    styles: overlayClassName = "",
}) {
    return (
        <div className={`${styles.backdrop} ${overlayClassName}`}>
            <Panel
                wrapperClassName={styles.panel}
                className={styles.panelBody}
                role="dialog"
                aria-label={title}
            >
                {title && <h2 className={styles.title}>{title}</h2>}
                {message && <p className={styles.message}>{message}</p>}

                <div className={styles.buttons}>
                    <button
                        type="button"
                        className={`${styles.button} ${styles.buttonSecondary}`}
                        onClick={() => callback?.()}
                    >
                        {callbackText}
                    </button>
                    {callbackText2 && (
                        <button
                            type="button"
                            className={`${styles.button} ${styles.buttonPrimary}`}
                            onClick={() => callback2?.()}
                        >
                            {callbackText2}
                        </button>
                    )}
                </div>
            </Panel>
        </div>
    );
}
